import {
  STASH, NOT_APPLICABLE, RECOMMENDATION_EVENTNAME, CART_ADD_RECS, PRODUCT_POD, ATC
} from '../constants';
import { getRecommendationType, getBipCartItems, getPageType } from '../thd-analytics-utils';
import { getState } from '../analytics-state';

// Race condition fix: in case pageType is not yet set in state. getPageType is the same
// function that populates state (route.listener.analytics.js), so the fallback stays in the
// state vocabulary rather than the DDO's, which uses different strings for the same pages.
// `||` (not `??`) matches the convention at every other state.pageType read site, which
// treat '' as absent; no writer actually stores '', so the two behave identically today.
const resolvePageType = () => getState()?.pageType || getPageType();

export const bundleMini = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('bundle-mini.viewBundleClick', ({ output }) => {
    const { itemId, product } = output ?? {};
    const pageType = resolvePageType();
    const analyticsEvent = {
      category: {
        primaryCategory: STASH,
      },
      eventInfo: {
        eventName: RECOMMENDATION_EVENTNAME,
      },
      eventMode: STASH,
      stash: {
        recommendation: {
          pageType,
          recommendationType: getRecommendationType(product),
          displayPosition: NOT_APPLICABLE,
          anchorProductSku: itemId,
          strategy: NOT_APPLICABLE,
          recommendationVersion: NOT_APPLICABLE,
          featureVersion: NOT_APPLICABLE,
          interval: NOT_APPLICABLE,
        },
      },
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(analyticsEvent);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('bundle-mini.bipAddToCart', ({ output }) => {
    const { items = [], product, anchorProductSku = NOT_APPLICABLE } = output;
    const pageType = resolvePageType();
    const ddoEvent = {
      eventInfo: {
        eventName: CART_ADD_RECS
      },
      category: {
        primaryCategory: STASH
      },
      eventMode: STASH,
      stash: {
        component: PRODUCT_POD,
        item: getBipCartItems(items, product, anchorProductSku, pageType),
        pageType,
        section: 'dyn prod rec',
        sharedSection: NOT_APPLICABLE,
        target: ATC
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('bundle-mini.laundryBipAddToCart', ({ output }) => {
    const { items = [], product } = output;
    const pageType = resolvePageType();
    const ddoEvent = {
      eventInfo: {
        eventName: CART_ADD_RECS
      },
      category: {
        primaryCategory: STASH
      },
      eventMode: STASH,
      stash: {
        component: PRODUCT_POD,
        item: items?.map((item) => {
          return {
            productID: item?.itemId,
            index: NOT_APPLICABLE
          };
        }),
        pageType,
        section: 'dyn prod rec',
        sharedSection: NOT_APPLICABLE,
        target: ATC,
        recommendation: {
          pageType,
          recommendationType: getRecommendationType(product),
          displayPosition: NOT_APPLICABLE,
          anchorProductSku: NOT_APPLICABLE,
          strategy: NOT_APPLICABLE,
          recommendationVersion: NOT_APPLICABLE,
          featureVersion: NOT_APPLICABLE,
          interval: NOT_APPLICABLE,
          sponsoredProduct: NOT_APPLICABLE
        },
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
};